import { boltApi } from 'store/queries/bolt-api'
import { GetUserEventLogsPayload, GetUserEventLogsResponse } from './types.ts'
import { Flow } from 'types/logging.ts'
import { TagTypes } from '../types.ts'
import { createErrorTransformer } from 'store/queries/utils.ts'

export const eventsBoltApi = boltApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET USER EVENT LOGS
    getUserEventLogs: builder.query<GetUserEventLogsResponse, GetUserEventLogsPayload>({
      query: ({ email }) => ({
        url: `/events/user?email=${encodeURIComponent(email)}`
      }),
      transformResponse: ({ data }) => {
        return data
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.EVENTS}:getUserEventLogs]`),
      providesTags: [TagTypes.EVENT_LOGS]
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUserEventLogsQuery } = eventsBoltApi
